import React from "react";
import "./EventCardSkeletons.css";

const EventCardSkeleton = () => {
  return (
    <div className="event-skeleton-card">
      <div className="event-skeleton-image shimmer" />
      <div className="event-skeleton-content">
        <div className="event-skeleton-line shimmer short" />
        <div className="event-skeleton-line shimmer" />
        <div className="event-skeleton-line shimmer" />
      </div>
    </div>
  );
};

export default EventCardSkeleton;